var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import { randomId } from "../utils/ui-utils";
import { SnackBar } from "./SnackBar";
// @ts-ignore
const SnackBarContext = React.createContext(null);
export function useSnackBar() {
    const dispatch = React.useContext(SnackBarContext);
    if (__DEV__) {
        if (!dispatch) {
            console.error(`You have to render you components inside SnackBarProvider before using useSnackBar`);
        }
    }
    return dispatch;
}
export const NotificationStatus = {
    SUCCESS: "SUCCESS",
    INFO: "INFO",
    ERROR: "ERROR",
};
function reducer(_state = [], action) {
    switch (action.type) {
        case "ADD":
            return [Object.assign({ key: randomId("snackbar") }, action.notification)];
        case "CLOSE":
            return [];
        default:
            // @ts-expect-error -- This is a type error
            throw new Error(`Unhandled action type ${action.type}`);
    }
}
export const SnackBarProvider = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    const [notifications, dispatch] = React.useReducer(reducer, []);
    let firstNotification = notifications[0];
    const handleClose = React.useCallback(() => {
        dispatch({ type: "CLOSE" });
    }, [dispatch]);
    return (_jsxs(SnackBarContext.Provider, Object.assign({ value: dispatch }, rest, { children: [children, firstNotification && (_jsx(SnackBar, { notification: firstNotification, onClose: handleClose }, firstNotification.key))] })));
};
//# sourceMappingURL=SnackBarContextNew.js.map